import { jsx as _jsx } from "react/jsx-runtime";
import { X } from 'lucide-react';
const ErrorDismissButton = ({ onClick }) => (_jsx("button", { type: "button", "aria-label": "Dismiss error", onClick: onClick, className: "shrink-0 text-secondary-text hover:text-primary-text transition-colors", children: _jsx(X, { className: "h-4 w-4" }) }));
export default ErrorDismissButton;
